"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FuehrungsrinneOpti = void 0;
var FuehrungsrinneOpti;
(function (FuehrungsrinneOpti) {
    FuehrungsrinneOpti[FuehrungsrinneOpti["RINNE_2M"] = 1519] = "RINNE_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["RINNE_GLEITSCHIENE_2M"] = 1520] = "RINNE_GLEITSCHIENE_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["GLEITSCHIENE_2M"] = 1521] = "GLEITSCHIENE_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["TWO_RINNE_2M"] = 1527] = "TWO_RINNE_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["TWO_RINNE_GLEITSCHIENE_2M"] = 1528] = "TWO_RINNE_GLEITSCHIENE_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["TWO_GLEITSCHIENE_2M"] = 1529] = "TWO_GLEITSCHIENE_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["ABLEGERINNE_EINZELND_1M"] = 1607] = "ABLEGERINNE_EINZELND_1M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["ABLEGERINNE_EINZELND_2M"] = 1608] = "ABLEGERINNE_EINZELND_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["ABLEGERINNE_WANDKONSOLE_1M"] = 1609] = "ABLEGERINNE_WANDKONSOLE_1M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["ABLEGERINNE_WANDKONSOLE_2M"] = 1610] = "ABLEGERINNE_WANDKONSOLE_2M";
    FuehrungsrinneOpti[FuehrungsrinneOpti["FESTPUNKTMODUL_RINNE"] = 1631] = "FESTPUNKTMODUL_RINNE";
    FuehrungsrinneOpti[FuehrungsrinneOpti["RINNE_MIT_DAEMPFUNGSPROFIL_2M"] = 1703] = "RINNE_MIT_DAEMPFUNGSPROFIL_2M";
})(FuehrungsrinneOpti = exports.FuehrungsrinneOpti || (exports.FuehrungsrinneOpti = {}));
//# sourceMappingURL=fuehrungsrinne-opti.js.map